/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpRightIcon32Regular = forwardRef('ArrowDUturnUpRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M19.684.77a1 1 0 1 0-1.368 1.46L24.471 8H14.5C8.701 8 4 12.701 4 18.5S8.701 29 14.5 29H22a1 1 0 1 0 0-2h-7.5a8.5 8.5 0 0 1 0-17h9.971l-6.155 5.77a1 1 0 1 0 1.368 1.46l6.444-6.041a3 3 0 0 0 0-4.378L19.684.771Z" })));
});
